/*
 * Application State should be all within this file.
 */

const app = {
  state: {
    value: "",
    sowOocyteCollection: {
      completed: false,
      completedAt: null
    }
  },
  mutations: {
    SET_VALUE(state, value) {
      state.value = value;
    },
    SET_SOW_OOCYTE_COLLECTION(state, payload) {
      state.sowOocyteCollection = {
        ...state.sowOocyteCollection,
        ...(payload || {})
      };
    }
  },
  actions: {
    setValue({ commit }, value) {
      commit("SET_VALUE", value);
    },
    setSowOocyteCollection({ commit }, payload) {
      commit("SET_SOW_OOCYTE_COLLECTION", payload);
    },
    mapFromDatastore({ commit, state }, payload) {
      let _payload = "";
      try {
        _payload = JSON.parse(payload);
      } catch (e) {
        _payload = payload;
      }

      commit("SET_VALUE", _payload?.value ?? state.value);
      const hydratedCollection =
        _payload?.sowOocyteCollection ||
        _payload?.bovineEmbryoCollection ||
        _payload?.embryo ||
        {};

      commit("SET_SOW_OOCYTE_COLLECTION", {
        completed:
          hydratedCollection?.completed ?? state.sowOocyteCollection.completed,
        completedAt:
          hydratedCollection?.completedAt ??
          state.sowOocyteCollection.completedAt
      });
    }
  },
  getters: {
    getSowOocyteCollection(state) {
      return state.sowOocyteCollection;
    },
    mapToDatastore(state) {
      let payload = {
        value: state.value,
        sowOocyteCollection: {
          completed: !!state.sowOocyteCollection.completed,
          completedAt: state.sowOocyteCollection.completedAt ?? null
        }
      };

      payload = JSON.stringify(payload);
      return payload;
    }
  }
};

export default app;
